import {
  GET_LOGGED_USER_DETAILS
} from '../ActionTypes/ActionTypes';

import UserService from '../Services/UserService';


export const getLoggedUserDetails = (userEmail) => async (dispatch) => {
  try {
     
        var  res = await UserService.getLoggedinUserDetails(userEmail);
        dispatch({
          type: GET_LOGGED_USER_DETAILS,
          payload: res.data,
      });
      return Promise.resolve(res.data);
  } catch (err) {
      console.log(err);
  }
};

export const getAllUsersAllRoles = () => async (dispatch) => {
  try {
    var res = await UserService.getAllUsersandAllRoles();
    return Promise.resolve(res.data);
  } catch (err) {
    console.log(err);
  }
};

export const getCurrentUserInfofromAD = async (userEmail) => {
  return await UserService.getUserInfofromAD(userEmail);
};
export const addNewUserDetails = async (data) => {
  return await UserService.SaveNewUserDetails(data);
};

export const addNewRoleDetails = async (data) => {
  return await UserService.SaveUpdateRoleAndPrevilage(data);
};
